import './css/cart.css';

function Cart(){
    return(
        <>
            
        <section className="cart-section">
            <div className="container">
                <div className="row">
                    <h1>  العربة <i className="fa-solid fa-cart-arrow-down"></i></h1>
                    <form action="?do=payment" method="POST" enctype="multipart/form-data">
                    
                        <div className="cart-content">



                            <h1>  العربة فارغة  </h1>
                        </div>

                    </form>
                </div>
            </div>
        </section>


        </>
    )
}

export default Cart;